import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { ErrorStore, GlobalErrorComponent } from '@frontend/shared';

@Component({
  standalone: true,
  imports: [RouterModule, GlobalErrorComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly #meta = inject(Meta);
  readonly #errorStore = inject(ErrorStore);

  readonly globalErrors = computed(() =>
    this.#errorStore.getErrorsByCodesAndTypeByPrefix(
      ['error.tenantConfig', 'error.unknown'],
      'global'
    )
  );

  readonly hasGlobalError = computed(() => this.globalErrors().length > 0);

  constructor() {
    const bodyStyles = window.getComputedStyle(document.body);
    const bgColor = bodyStyles.getPropertyValue('--background-color');
    this.#meta.addTag({ name: 'theme-color', content: bgColor });
    this.#meta.addTag({
      name: 'theme-color',
      content: bgColor,
      media: '(prefers-color-scheme: light)',
    });
    this.#meta.addTag({
      name: 'theme-color',
      content: bgColor,
      media: '(prefers-color-scheme: dark)',
    });
  }

  reload(): void {
    window.location.reload();
  }
}
